module.exports = __webpack_public_path__ + "img/ico-write.dcf6ecba.svg";